import React from 'react';
import { ShieldCheck, Lock } from 'lucide-react';
import { CTAButton } from './CTAButton';
export const PricingSection: React.FC = () => {
  return <section id="compra" className="py-20 bg-green-900 text-white relative" data-id="element-81">
      <div className="container mx-auto px-4 relative z-10" data-id="element-82">
        <div className="max-w-3xl mx-auto bg-white text-gray-900 rounded-3xl shadow-2xl overflow-hidden" data-id="element-83">
          {/* Header */}
          <div className="bg-amber-400 p-6 text-center" data-id="element-84">
            <h2 className="text-2xl md:text-3xl font-bold text-amber-900" data-id="element-85">
              Accedé hoy con precio promocional
            </h2>
            <p className="text-amber-800 font-medium" data-id="element-86">
              Esta promoción puede finalizar en cualquier momento
            </p>
          </div>

          {/* Body */}
          <div className="p-8 md:p-12 text-center" data-id="element-87">
            <div className="flex justify-center items-center gap-4 mb-6" data-id="element-88">
              <span className="text-gray-400 text-xl line-through decoration-red-500" data-id="element-89">
                $67 USD
              </span>
              <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full font-bold text-sm" data-id="element-90">
                AHORRAS 70%
              </div>
            </div>

            <div className="mb-8" data-id="element-91">
              <span className="text-6xl md:text-7xl font-extrabold text-green-700 tracking-tight" data-id="element-92">
                $19.97
              </span>
              <span className="text-gray-500 text-xl font-medium block mt-2" data-id="element-93">
                Pago único • Acceso de por vida
              </span>
            </div>

            <div className="space-y-4 mb-10 max-w-md mx-auto" data-id="element-94">
              {['Acceso inmediato al MegaPack completo', 'Descarga digital de todos los archivos', 'Material 100% imprimible', 'Los 4 Bonos de regalo incluidos', 'Actualizaciones futuras gratuitas'].map((item, i) => <div key={i} className="flex items-center gap-3 text-left" data-id="element-95">
                  <div className="bg-green-100 p-1 rounded-full flex-shrink-0" data-id="element-96">
                    <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-97" />
                  </div>
                  <span className="text-gray-700" data-id="element-98">{item}</span>
                </div>)}
            </div>

            <div className="flex flex-col gap-4" data-id="element-99">
              <a href="Link de tu checkout" className="w-full block bg-amber-500 hover:bg-amber-400 text-white font-bold text-xl py-4 rounded-xl shadow-lg border-b-4 border-amber-700 hover:border-amber-600 transition-all transform hover:-translate-y-1" data-id="element-100">
                Acceder al MegaPack con Descuento
              </a>

              <div className="flex items-center justify-center gap-2 text-gray-400 text-sm" data-id="element-101">
                <Lock className="w-3 h-3" data-id="element-102" />
                <span data-id="element-103">Pago 100% Seguro y Encriptado</span>
              </div>
            </div>
          </div>

          {/* Guarantee */}
          <div className="bg-stone-100 p-6 border-t border-stone-200" data-id="element-104">
            <div className="flex flex-col md:flex-row items-center gap-4 text-center md:text-left" data-id="element-105">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm flex-shrink-0" data-id="element-106">
                <ShieldCheck className="w-8 h-8 text-green-600" data-id="element-107" />
              </div>
              <div data-id="element-108">
                <h4 className="font-bold text-gray-900" data-id="element-109">
                  Garantía de Satisfacción (7 días)
                </h4>
                <p className="text-sm text-gray-600" data-id="element-110">
                  Si descargás el pack y sentís que no te sirve para tu realidad
                  docente, pedís el reembolso y listo. Sin vueltas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};